import React, { useState } from 'react';
import './SupportPage.css';

const SUPPORT_FORM_URL = 'https://forms.office.com/Pages/ResponsePage.aspx?id=k3jpCVwssk-7NC_lqy5YeAL_tslMkYVKvZRXFuvu2fNUQkpJTUtaSkpCV1BHSVc0OTQwWkI1U0ZGQi4u&embed=true';

const SupportContent = ({ variant = 'public' }) => {
  const [isFrameLoading, setIsFrameLoading] = useState(true);

  return (
    <div className={`support-content support-content--${variant}`}>
      <h1 className="support-page-title">Submit a Demo Support Ticket</h1>

      <section className="support-form-container" aria-label="Demo support ticket form">
        {isFrameLoading && (
          <div className="support-loader" role="status" aria-live="polite">
            <span className="support-loader-ring" aria-hidden="true"></span>
            Loading form...
          </div>
        )}
        <iframe
          className="support-iframe"
          title="Demo Support Ticket Form"
          src={SUPPORT_FORM_URL}
          onLoad={() => setIsFrameLoading(false)}
          allowFullScreen
        />
      </section>
    </div>
  );
};

export default SupportContent;
